import { Box, Typography } from '@mui/material'
import React from 'react'

const Changelog = () => {
    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3, height: "90vh" }}>
            <Typography variant="h6" component="div">
                03/29/2023
            </Typography>
            <ul>
                <li>Fixed typo on dashboard disclaimer text</li>
                <li>Added SGLT2 inhibitor to medication history</li>
                <li>Fixed display fields bug of sending multiple data center keys</li>
                <li>Changed sub filter numeric field card layout to account for longer operators</li>
                <li>Separated out the lookup tables for icd and cpt codes</li>
                <li>Fixed saved queries showing duplicate queries after saving</li>
                <li>Query Filters
                    <ul>
                        <li>Changed filter to use list instead of accordian and changed the layout of child filters</li>
                        <li>Added or in between filters</li>
                        <li>Simplified the name of filter and child filter selection</li>
                    </ul>
                </li>
            </ul>

            <Typography variant="h6" component="div">
                03/09/2023
            </Typography>
            <ul>
                <li>Added Email Change</li>
                <li>Fixed chadvasc metadata operator causing patient count to return 0</li>
                <li>Added info prompt to dashboard</li>
                <li>Run / Execute Query Modal
                    <ul>

                        <li>Added additional instructions to top of modal content</li>
                        <li>Changed wording of categories and columns</li>
                        <li>Simplified selected fields</li>
                        <li>Fixed bug of re-adding all fields even if you cleared them</li>
                        <li>Added delete to additional fields</li>
                        <li>Fixed adding duplicate fields bug</li>
                    </ul>
                </li>
            </ul>

            <Typography variant="h6" component="div">
                02/17/2023
            </Typography>
            <ul>
                <li>Fixed infite scroll and added it to sub child filters as well</li>
                <li>Added ICD and CPT codes to query builder for lookup</li>
                <li>Added code columns to each category that was missing them</li>
                <li>Changed Run to open modal and have ability to select columns to display</li>
            </ul>

            <Typography variant="h6" component="div">
                01/31/2023
            </Typography>
            <ul>
                <li>Added search filters (contains, starts with and ends with)</li>
                <li>Fixed vital sign code not showing any data</li>
                <li>Added vital sign value sub filter</li>
                <li>Fixed subchild operator not showing</li>
                <li>Added label to vital sign value</li>
                <li>Added missing and requested columns to filters</li>
                <li>Title Cased all table headers</li>
                <li>Fixed undo/redo bug</li>
                <li>Fixed child operator selection not displaying on main filter</li>
            </ul>

            <Typography variant="h6" component="div">
                01/19/2023
            </Typography>
            <ul>
                <li>Added infite scroll to datagrid (still some bugs to fix)</li>
                <li>Added translations to filters and child filters</li>
                <li>Added operators to each filter</li>
                <li>Added copy icon so you can copy child filters to same category filter</li>
                <li>Added Documents category to Patient Data and disabled it by default</li>
                <li>Updated metadata to accomodate for the changes above</li>
                <li>Created services for api calls</li>
            </ul>

            <Typography variant="h6" component="div">
                01/08/2023
            </Typography>
            <ul>
                <li>Changed Question Text to Patient Questions</li>
                <li>Changed Answer Text to Patient Answers</li>
                <li>Made all Accordian filters to always be open</li>
            </ul>

            <Typography variant="h6" component="div">
                01/04/2023
            </Typography>
            <ul>
                <li>Fixed answer text not showing for some category questions</li>
                <li>Added undo and redo to filters</li>
                <li>Disabled save button when no filter is selected</li>
                <li>Fixed loading for each child/sub filter</li>
            </ul>

            <Typography variant="h6" component="div">
                01/03/2023
            </Typography>
            <ul>
                <li>Added dark mode</li>
                <li>
                    Added onBoarding test experience for query builder using help button
                </li>
                <li>Fixed risk score filter in metadata</li>
                <li>Fixed overlapping of modal title with appbar</li>
                <li>Changed UI a bit</li>
            </ul>

            <Typography variant="h6" component="div">
                12/29/2022
            </Typography>
            <ul>
                <li>Modified the metadata to adapt to new UI</li>
                <li>
                    Updated app UI flow to reduce number of clicks and modified logic{" "}
                </li>
                <li>
                    Changed the patient count to only get new count when clicked on
                    refresh button
                </li>
                <li>
                    Removed advancedMode for now - while we discuss how to implement in
                    our current UI flow
                </li>
                <li>Added filters with sub/child filters for each category</li>
                <li>
                    Added DataGrid, DatePicker and TextField filters based on dataType
                </li>
                <li>
                    Changed Query Execution results to open in modal instead of
                    redirecting to page
                </li>
                <li>Saved Queries - Fixed opening query</li>
                <li>Updated profile page</li>
                <li>
                    Added svg for no data on saved queries page is no queries are present
                </li>
                <li>
                    Removed back button if coming from a saved query to prevent validation
                    lock up
                </li>
                <li>Added filters to query info card on the right</li>
                <li>Added clear filters to top right of card</li>
            </ul>

            <Typography variant="h6" component="div">
                11/10/2022
            </Typography>
            <ul>
                <li>Changed wording for patient count box</li>
                <li>Fixed NaN showing for pagination due to comma</li>
                <li>Flipped the ordering dropdown for query sorts</li>
                <li>
                    Medication History
                    <ul>
                        <li>
                            Fixed duplicate entries in fields by setting metadata column to
                            null
                        </li>
                        <li>Removed parent dependency for individual filters</li>
                    </ul>
                </li>
                <li>Lab Results - added individual filters</li>
                <li>Saved Queries - changed run to open</li>
            </ul>

            <Typography variant="h6" component="div">
                10/25/2022
            </Typography>
            <ul>
                <li>
                    Fixed filter modal closing when searching columns in datagrid (table)
                </li>
                <li>Changed dashboard to changelog in sidebar</li>
                <li>
                    Added more options to operator dropdown (contains, begins with, ends
                    with)
                </li>
                <li>Added placeholder for searchbar</li>
                <li>
                    Changed the select button that opens filter modal to be a searchbar
                    with search icon
                    <ul>
                        <li>
                            This will allow you to enter the value you want to search or just
                            enter value you want to use with selected operator
                        </li>
                    </ul>
                </li>
                <li>Added loading to datagrid inside the filter modal</li>
                <li>
                    Medication History
                    <ul>
                        <li>Changed Medication filter to Medication Filter Wizard</li>
                        <li>Added individual filter options as well</li>
                        <li>
                            Individual Medication Name filter now also shows strength,
                            medication code, and code system
                        </li>
                    </ul>
                </li>
                <li>Allowed code system in medication history to be any</li>
                <li>
                    Save Query
                    <ul>
                        <li>
                            Fixed issue which prevented user to move forward after pressing
                            save query button
                        </li>
                        <li>
                            Fixed save query method to make sure we are not adding another
                            query and instead replacing the previous query with the current
                            saved version
                        </li>
                    </ul>
                </li>
            </ul>
        </Box>
    )
}

export default Changelog